<template>
    <div class="modal-card" ref="element">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ editEnabled ? "Edit Question" : "Add Question" }}</p>
        </header>
        <section class="modal-card-body">
            <b-field label="Question Text:">
                <b-input type="text" v-model="qText" placeholder="Question Text"
                    :disabled="role === 'viewer' || editEnabled"></b-input>
            </b-field>
            <b-field v-if="bQuestionError" style="color: red">
                Please enter question text.
            </b-field>
            <b-field label="Question Text (Albanian):">
                <b-input type="text" v-model="qTextAl" placeholder="Question Text (Albanian)"
                    :disabled="role === 'viewer' || editEnabled"></b-input>
            </b-field>
            <b-field v-if="bQuestionAlError" style="color: red">
                Please enter question text in Albanian.
            </b-field>
            <b-field v-if="!editEnabled" style="color: red; font-size: small;">
                Please be careful when adding question texts. Once submitted, these fields cannot be changed.
            </b-field>
            <hr>
            <p style="margin-top:-10px; margin-bottom: 10px">Question Answers:</p>
            <b-table :mobile-cards="false" :data="tableData.length > 0 ? tableData : []" striped>

                <template slot-scope="props">
                    <b-table-column field="name" label="Answer" centered>
                        {{ props.row.text }}
                    </b-table-column>
                    <b-table-column label="Edit/Remove" centered>
                        <b-button type="is-info" icon-left="edit" @click="editAnswerModal(props.index)"></b-button>
                        <b-button :disabled="role === 'viewer'" type="is-danger" icon-left="trash"
                            @click="confirmRemoveAnswer(props.index, props.row.text)"></b-button>
                    </b-table-column>
                </template>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>No answers to display.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </section>
        <footer class="modal-card-foot" style="background-color:white;border-radius:0px">
            <b-button type="is-success" icon-left="plus" @click="addAnswerModal" :disabled="role === 'viewer'">Add
                answer</b-button>
            <p><b>No. of answers: {{ options.length }}</b></p>
        </footer>
        <footer class="modal-card-foot">
            <b-button type="is-info" @click="saveQuestion" v-if="editEnabled"
                :disabled="role === 'viewer'">Submit</b-button>
            <b-button type="is-info" icon-left="plus" @click="addQuestion" v-else :disabled="role === 'viewer'">Add
                new
                question</b-button>
            <b-button type="is-light" @click="closeModal()">Cancel</b-button>
        </footer>
    </div>
</template>

<script>
import AnswerAddEdit from './AnswerAddEdit.vue'

export default {
  name: 'QuestionAddEdit',
  props: ['editEnabled', 'propQuestion', 'propId', 'propParentFn', 'questionnaireId'],
  data: () => {
    return {
      editStaticQuestionRef: {},
      qText: '',
      qTextAl: '',
      options: [],
      questionId: '',
      tableData: [],
      bQuestionError: false,
      bQuestionAlError: false
    }
  },
  computed: {
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  mounted: function () {
    if (this.editEnabled) {
      this.questionId = this.propId
      this.editStaticQuestionRef = this.propQuestion
      this.qText = this.editStaticQuestionRef.text
      this.qTextAl = this.editStaticQuestionRef.textAl
      if (this.editStaticQuestionRef.options) {
        this.options = Object.keys(this.editStaticQuestionRef.options).map(key => ({id: Number(key), ...this.editStaticQuestionRef.options[key]}))
      }
      for (let aId in this.options) {
        this.tableData.push({ id: aId, ...this.options[aId] })
      }
    }
  },
  methods: {
    refreshAnswersTable () {
      this.tableData = []
      for (let aId in this.options) {
        this.tableData.push({ id: aId, ...this.options[aId] })
      }
    },
    addAnswerModal () {
      this.$buefy.modal.open({
        parent: this,
        component: AnswerAddEdit,
        props: { propParentFn: this.receiveAnswerFromChild, questionId: this.questionId, questionnaireId: this.questionnaireId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    receiveAnswerFromChild (option) {
      this.options.push(option)
      this.refreshAnswersTable()
    },
    confirmRemoveAnswer (id, answerName) {
      if (this.role !== 'viewer') {
        this.$buefy.dialog.confirm({
          message: 'Do you want to <b>delete</b> answer "' + answerName + '"?',
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            this.options = this.options.filter((x) => { return this.options.indexOf(x) !== parseInt(id) })
            this.refreshAnswersTable()
          }
        })
      }
    },
    editAnswerModal (id) {
      this.$buefy.modal.open({
        parent: this,
        component: AnswerAddEdit,
        props: { editEnabled: true, propAnswer: this.options[id], propId: id, propParentFn: this.updateAnswerFromChild, questionId: this.questionId, questionnaireId: this.questionnaireId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    updateAnswerFromChild (option, id) {
      this.options[id] = option
      this.refreshAnswersTable()
    },
    addQuestion () {
      if (this.role !== 'viewer') {
        this.bQuestionError = false
        this.bQuestionAlError = false
        if (this.qText === '') {
          this.bQuestionError = true
        } else if (this.qTextAl === '') {
          this.bQuestionAlError = true
        } else {
          let newQuestionRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            newQuestionRef = this.$store.state.database.ref('/neoslide/questionnaires/' + this.workspaceId + '/' + this.questionnaireId).push()
          } else {
            newQuestionRef = this.$store.state.database.ref('/questionnaires/' + this.userId + '/' + this.questionnaireId).push()
          }
          let newQuestionId = newQuestionRef.key
          let question = {
            type: 1,
            text: this.qText,
            textAl: this.qTextAl,
            id: newQuestionId,
            options: this.options
          }
          this.propParentFn(question)
          this.$parent.close()
        }
      }
    },
    saveQuestion () {
      this.bQuestionError = false
      this.bQuestionAlError = false
      if (this.role !== 'viewer') {
        if (this.qText === '') {
          this.bQuestionError = true
        } else if (this.qTextAl === '') {
          this.bQuestionAlError = true
        } else {
          let updatedQuestion = {
            type: 1,
            text: this.qText,
            textAl: this.qTextAl,
            id: this.questionId,
            options: this.options
          }
          this.propParentFn(updatedQuestion, this.questionId)
          this.closeModal()
        }
      }
    },
    cancelEdit () {
      if (this.editEnabled) {
        this.name = this.editStaticQuestionnaireRef.name
        this.questions = [...this.editStaticQuestionnaireRef.questions]
      }
      this.closeModal()
    },
    closeModal () {
      this.$parent.close()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/questionnaires/QuestionAddEdit.vue